const HEALTH_TAB = {
  BODY: "BODY",
  MEAL: "MEAL",
  ACTIVITY: "ACTIVITY",
};

export default HEALTH_TAB;
